import React from 'react'
import { observer} from 'mobx-react'
import { Text} from '../../vanilla'
import { Nullable } from '../../types/utils'

export interface PricePerUnitProps {
  price: Nullable<number>
  customPriceAmount?: Nullable<number>
  priceInfo?: {perUnit: string; [price: number]: string; wasPrice: string}
  promotionPrice: Nullable<number>
}

export const PricePerUnitContainer = (props: PricePerUnitProps) => {
  const {
    priceInfo,
    price,
    customPriceAmount,
    promotionPrice = null,
  } = props

  const priceAmount = promotionPrice ?? customPriceAmount ?? price

  if (!priceAmount) {
    return null
  }

  const pricePerUnit = priceInfo?.[priceAmount]?.replace(/^0+/, '')

  if (!pricePerUnit || !priceInfo?.perUnit) {
    return null
  }

  return (
    <Text
      variant="text1Light"
      color="textMuted"
      lineHeight="none"
    >
      {pricePerUnit}/{priceInfo?.perUnit}
    </Text>
  )
}

export const PricePerUnit = observer(PricePerUnitContainer)
